<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :mask="false"
      notFooterPadding
      :contentStyle="{'height': '100%'}"
      @open="modalOpen"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>添加商品</span>
    </template>
    <template #content>
      <app-base-main
          :table-shadow="false"
          :no-padding="true"
          parentTable
          >
        <template #filter-group>
          <app-filter-group @reset="$gjReset" @query="$gjNoticeQuery">
            <gj-country-server-select v-model="filter.countryMarketValue"></gj-country-server-select>
            <gj-select
              v-model="filter.status"
              :options="listingStatus"
              placeholder="全部状态"
            ></gj-select>
            <gj-select-input
              v-model="filter.keyword"
              :options="[
                {id: 'asinList', text: 'ASIN', moreShow: true },
                {id: 'mskuList', 'text': 'MSKU', moreShow: true},
                {id: 'fnskuList', 'text': 'FNSKU', moreShow: true},
                {id: 'productName', text: '产品名称'},
                {id: 'sku', text: 'SKU'},
              ]"
              :singe-input="true"
              :width="['110px', '200px']">
            </gj-select-input>
          </app-filter-group>
        </template>
        <template #table>
          <gj-table
            ref="gjTable"
            adaptParent
            :index="false"
            name="printProductLabel"
            :loading="loading"
            :data="tableData"
            :columns="columns"
            :offset-height="54"
            selection
            :show-overflow="false"
            :pagination="pagination"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">
            <template v-slot:productName="{row}">
              <div>
                <gj-text width="90%">{{ row.productName | defaultShow }}</gj-text>
              </div>
              <div>
                <gj-tooltip :text-line="1" :content="row.sku">{{
                row.sku | defaultShow
                }}</gj-tooltip>
              </div>
            </template>
            <template v-slot:asin="{row}">
              <div>
                <gj-text width="90%">{{ row.asin | defaultShow }}</gj-text>
              </div>
              <div>
                {{ row.msku | defaultShow }}
              </div>
            </template>
            <template v-slot:status="{ row }">
              <gj-tag type="text" :color="getColor(row.status)">{{ row.status | optionText(listingStatustwo) }}</gj-tag>
            </template>
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, queryMixin, selectionMixin} from "@/minxins";
  import {ProductEnum, listingStatus, listingStatustwo} from "@/utils/options";
  import {defaultVal, isMeaningful} from "@/utils/common";
  import { getSimpleListings } from '@/api/sale';
  import { tagColors } from '@/components/tag/tag-colors';
  import { mapGetters } from 'vuex';

  export default {
    name: "app-add-print-goods",
    mixins: [modalMixIn, queryMixin, selectionMixin],
    props: {
      hideIds: {
        type: Array,
        default: () => []
      },
      withWarehouse: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        tableData: [],
        columns: [
          {
            id: 'picture',
            header: '图片',
            field: 'picture:imageUrl',
            minWidth: '60px',
            fixed: 'left',
          },
          {
            id: 'productName',
            header: '产品名称/SKU',
            field: 'slot:productName',
            minWidth: '120px',
          },
          {
            id: 'asin',
            header: 'ASIN/MSKU',
            field: 'slot:asin',
            fixed: 'left',
            minWidth: '120px',
          },
          { id: 'status', header: '状态', field: 'slot:status', minWidth: '80px'},
          { id: 'fnsku', header: 'FNSKU', field: 'fnsku', minWidth: '100px'},
          {
            id: 'marketId',
            header: '店铺/国家',
            field: 'option:marketId',
            minWidth: '120px',
            options: () => this.marketOption,
          }
        ],
        filter: {
          countryMarketValue: null,
          status: null,
          keyword: {
            key: 'asinList',
            value: null
          }
        },
        ProductEnum: ProductEnum,
        listingStatus,
        listingStatustwo,
        tagColors
      }
    },
    created() {
      if(this.withWarehouse) {
        this.columns.splice(5, 0, { id: 'warehouseName', header: '仓库', field: 'warehouseName', minWidth: '120px' })
      }
    },
    computed: {
      ...mapGetters({
        marketOption: 'marketOption',
      }),
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            status: this.filter.status,
            withWarehouse: this.withWarehouse,
            excludeListingIds: this.hideIds,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        params.model[this.filter.keyword.key] = this.filter.keyword.value;
        if((['asinList','mskuList', 'fnskuList'].includes(this.filter.keyword.key))){
          if(this.filter.keyword.value){
            params.model[this.filter.keyword.key] = this.filter.keyword.value.split(',');
          }else{
            params.model[this.filter.keyword.key] = [];
          }
        }
        if (isMeaningful(this.filter.countryMarketValue)) {
          params.model.marketIds = this.filter.countryMarketValue.marketIds;
          params.model.countryCodes = this.filter.countryMarketValue.countryIds;
        }
        // 查询
        this.loading = true;
        getSimpleListings(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = data.records;
              this.pagination = this.getPagination(data);
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          });
      },
      $gjQueryInitParams() {
      return {
        filter: {
          countryMarketValue: null,
          status: null,
          keyword: {
            key: 'asinList',
            value: null
          }
        },
      };
    },
      getColor(status) {
        switch (status) {
          case 'Active':
            return this.tagColors.greenText;
          case 'Inactive':
            return this.tagColors.gray9Text;
          case 'Incomplete':
            return this.tagColors.orangeText;
          case 'Delete':
            return this.tagColors.gray6Text;
        }
      },
      confirm() {
        if (this.selectedRows.length === 0) {
          this.$gjMessage.error('请勾选商品');
          return;
        }
        this.$emit('select', this.selectedRows);
        this.$gjDestroy();
      }
    }
  }
</script>

<style scoped>
  .add-product-btn {
    margin: 5px 0 10px;
  }
</style>
